<label class="checkbox-wrapper" *ngIf="parentForm" [formGroup]="parentForm" [ngClass]="ngClasses" role="radio" [attr.aria-checked]="checked" [attr.for]="id">
	<input [attr.id]="id" [attr.checked]="checked" type="checkbox" autocomplete="false" [attr.disabled]="disabledForm ? true : null" class="checkbox" [formControlName]="formControlName">
	<span [ngClass]="{'align-right': align_right}">
		<label class="{{hideLabel ? 'visuallyhidden' : ''}}" [attr.for]="id">
			<span skeletonLoader [translationKey]="labelKey">
				{{label}}
			</span>
		</label>
	</span>
</label>

<label class="checkbox-wrapper" *ngIf="!parentForm" [ngClass]="ngClasses" role="radio" [attr.aria-checked]="checked" [attr.for]="id">
	<input [attr.id]="id" [(ngModel)]="value" [attr.checked]="checked" type="checkbox" [attr.disabled]="disabledForm ? true : null" autocomplete="false" class="checkbox">
	<span [ngClass]="{'align-right': align_right}">
		<label class="{{hideLabel ? 'visuallyhidden' : ''}}" [attr.for]="id">
			<span skeletonLoader [translationKey]="labelKey">
				{{label}}
			</span>
		</label>
	</span>
</label>

